export default __webpack_public_path__ + "static/media/fasting@3x.5a79de73.jpg";